
// routes.tsx
import * as React from "react";
import type { RouteObject } from "react-router-dom";

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MeverPage from "../pages/mever/page";
import MeverDetailPage from "../pages/mever/detail";
import MirariEchoPage from "../pages/mirari-echo/page";
import CompanyPage from "../pages/company/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mever",
    element: <MeverPage />,
  },
  {
    path: "/mever/:productId",
    element: <MeverDetailPage />,
  },
  {
    path: "/mirari-echo",
    element: <MirariEchoPage />,
  },
  {
    path: "/company",
    element: <CompanyPage />,
  },
  {
    // Catch‑all route for undefined paths
    path: "*",
    element: <NotFound />,
  },
];

// Export the routes array; if any unexpected characters were present after this line they have been removed.
export default routes;
